const HandsonsData_Users = {}

HandsonsData_Users.defaultState = {
  activeTab: '1',

  stateModal: false,
  messege: 'sample messege',
  messege2: '',
  messege3: '',
  messege4: '',
  messege5: '',

  write_disabled: true,
  delete_disabled: true,
  mail_disabled: true,
  Button_hidden: false,
  New_hidden: true,
  Details_hidden: true,
  Admin_hidden: true,

  Btn_hidden_Regist: true,
  Btn_hidden_Fix: true,
  Btn_hidden_Cansel: true,
  Btn_hidden_EditSave: true,
  Btn_hidden_Remand: true,
  Btn_hidden_Approval: true,
}


HandsonsData_Users.colHeaders_Name = [
  '選択',
  'Group No<br>（Disti ID）',
  'Group Name',
  'User Name',
  'Login ID',
  'Password',
  'Mail',
  'Page<br>Document<br>Request',
  'Page<br>CFAR<br>Request',
  'Page<br>Document',
  'Page<br>CFAR',
  'Page<br>Customer',
  'Page<br>Users',
  'Page<br>Logs',
  // '作成日' 
  // '権限<br>Tools',
  // '権限<br>依頼管理<br>Document<br>（全件表示）',
  // '権限<br>依頼管理<br>CFAR<br>（全件表示）',
  // 'yobi' 
];




HandsonsData_Users.columns_Data = [
  {
    data: 'delete_Flag',
    type: "checkbox",
    className:'htCenter',
    checkedTemplate: "1",
    uncheckedTemplate: "0"
  },
  { data: 'User_GroupID',     className:'htRight', },
  { data: 'User_GroupName' },
  { data: 'User_Name' },
  { data: 'User_ID' },
  { data: 'User_Pass' },
  { data: 'User_Mail' },
  {
    data: 'auth_OrderDocument',
    type: "checkbox",
    className:'htCenter',
    checkedTemplate: "1",
    uncheckedTemplate: "0"
  },
  {
    data: 'auth_OrderCFAR',
    type: "checkbox",
    className:'htCenter',
    checkedTemplate: "1",
    uncheckedTemplate: "0"
  },
  {
    data: 'auth_Document',
    type: "checkbox",
    className:'htCenter',
    checkedTemplate: "1",
    uncheckedTemplate: "0"
  },
  {
    data: 'auth_CFAR',
    type: "checkbox",
    className:'htCenter',
    checkedTemplate: "1",
    uncheckedTemplate: "0"
  },
  {
    data: 'auth_Costomer',
    type: "checkbox",
    className:'htCenter',
    checkedTemplate: "1",
    uncheckedTemplate: "0"
  },
  {
    data: 'auth_Users',
    type: "checkbox",
    className:'htCenter',
    checkedTemplate: "1",
    uncheckedTemplate: "0"
  },
  {
    data: 'auth_Logs',
    type: "checkbox",
    className:'htCenter',
    checkedTemplate: "1",
    uncheckedTemplate: "0"
  },
  // {data: 'create_time', readOnly: true },

  // {
  //   data: 'auth_Tools',
  //   type: "checkbox",
  //   className:'htCenter',
  //   checkedTemplate: "1",
  //   uncheckedTemplate: "0"
  // },
  // {
  //   data: 'auth_OrderDocumentAll',
  //   type: "checkbox",
  //   className:'htCenter',
  //   checkedTemplate: "1",
  //   uncheckedTemplate: "0"
  // },
  // {
  //   data: 'auth_OrderCFARAll',
  //   type: "checkbox",
  //   className:'htCenter',
  //   checkedTemplate: "1",
  //   uncheckedTemplate: "0"
  // },
  // {
  //   data: 'yobi',
  //   type: "checkbox",
  //   checkedTemplate: "1",
  //   uncheckedTemplate: "0"
  // },
];


HandsonsData_Users.data = [
];

HandsonsData_Users.sampledata = [
  {
    delete_Flag: "0",
    User_GroupID: "",
    User_GroupName: "",
    User_Name: "",
    User_ID: "",
    User_Pass: "",
    User_Mail: "",
    auth_Document: "0",
    auth_CFAR: "0",
    auth_OrderDocument: "0",
    auth_OrderCFAR: "0",
    auth_Costomer: "0",
    auth_Users: "0",
    auth_Logs: "0",
    partition_key: "User",
    create_time: '',
    mode: "",
    type: "",
    status: "",
    // auth_Tools: "0",
    // auth_OrderDocumentAll: "0",
    // auth_OrderCFARAll: "0",
  },
];

export default HandsonsData_Users
